'use client';

import React, { useState, useEffect, useRef } from 'react';
import Link from "next/link";
import * as ReactDOM from "react-dom";
import clsx from "clsx";
import OurHotelSearch from './OurHotelSearch';
import { X } from "lucide-react";

const Sidebar = ({onClick}) => {
  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [ourHotelPopup, setOurHotelPopup] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    const checkScreen = () => {
      const desktop = window.innerWidth >= 768;
      setIsDesktop(desktop);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSidebar = () => setOpen(prev => !prev);
  const closeSidebar = () => {
    
    setOpen(false)};

  return (
    <>
      {/* ☰ Toggle Button */}
      <button
        className="clarks-sidebar-toggler"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        <span />
        <span />
        <span />
      </button>

      {/* 🔲 Overlay */}
      {open && (
        <div className="clarks-sidebar-overlay" onClick={closeSidebar}></div>
      )}

      {/* 📑 Sidebar */}
      <div
        className={clsx("clarks-sidebar", {
          open,
          "clarks-sidebar-scrolled": isScrolled,
        })}
      >
        {/* ✖️ Close Button */}
        <div className="clarks-sidebar-header">
          <button
            className="clarks-sidebar-close"
            onClick={closeSidebar}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* 📄 Menu */}
        <ul className="clarks-sidebar-menu">
          <li><Link href="/" onClick={closeSidebar}>Home</Link></li>
          <li><a href="#" onClick={(e) => {
            e.preventDefault();
            setOurHotelPopup(true);
            closeSidebar();
          }}>Hotels</a></li>
          <li><Link href="/about" onClick={closeSidebar}>About Us</Link></li>
          <li><Link href="/orange-tiger-offers" onClick={closeSidebar}>Offers</Link></li>
          <li><Link href="/careers" onClick={closeSidebar}>Careers</Link></li>
          <li><Link href="/our-brands" onClick={closeSidebar}>Brands</Link></li>
          <li><Link href="/partner-with-us" onClick={closeSidebar}>Partner</Link></li>
          <li><Link href="/privacy-policy" onClick={closeSidebar}>Privacy Policy</Link></li>
          <li><Link href="/terms-and-conditions" onClick={closeSidebar}>Terms And Conditions</Link></li>
          <li><Link href="/contact" onClick={closeSidebar}>Contact</Link></li>
          <li><Link href="/blog" onClick={closeSidebar}>Blogs</Link></li>

          {/* <li>
            <a href="#" className="box-btn know-more p-2" onClick={()=>{closeSidebar(); onClick();}}>Book Now</a>
          </li> */}
        </ul>
      </div>

      {ourHotelPopup && typeof window !== "undefined" &&
        ReactDOM.createPortal(
          <div
            ref={popupRef}
            className="our-hotels-popup-for-data dropdown-menu show p-3 pt-0"
            style={{ maxHeight: "85vh", overflowY: "auto", overflowX: "hidden", top: "77px", zIndex: "10001"}}
          >
            <OurHotelSearch onClick={onClick}/>
            <button className="closebtnfor-our-hotel-popup"
              onClick={() => setOurHotelPopup(false)}
            ><X /></button>
          </div>,
          document.body
        )}
    </>
  );
};

export default Sidebar;
